import { E as EventProperties$1 } from "./axios-5f69b112.js";
const BUTTON = {
  type: "Button"
}, TEXTBOX = {
  type: "Input"
}, INPUT = {
  type: "Input"
}, FORM = {
  type: "Form"
}, CARD = {
  type: "Card"
}, FILTER = {
  type: "Option"
}, CONTENT = {
  type: "Content"
}, DROPDOWN = {
  type: "DropDown"
}, OPTION = {
  type: "Option"
}, MODAL = {
  type: "Modal"
}, INTERSTITIAL = {
  type: "Interstitial"
}, BANNER = {
  type: "Banner"
}, LIST$1 = {
  type: "List"
}, PIN = {
  type: "Pin"
}, ANALYTICS_EVENT = {
  type: "AnalyticsEvent"
}, DESTINATION_SEARCH = {
  type: "DestinationSearch"
}, MAP_PAN_ZOOM = {
  type: "MapPanZoom"
}, PAGE = {
  type: "Page"
}, NOTICE = {
  type: "Notice"
}, IMAGE = {
  type: "Image"
}, TAB = {
  type: "Tab"
}, ObjectProperties$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ANALYTICS_EVENT,
  BANNER,
  BUTTON,
  CARD,
  CONTENT,
  DESTINATION_SEARCH,
  DROPDOWN,
  FILTER,
  FORM,
  IMAGE,
  INPUT,
  INTERSTITIAL,
  LIST: LIST$1,
  MAP_PAN_ZOOM,
  MODAL,
  NOTICE,
  OPTION,
  PAGE,
  PIN,
  TAB,
  TEXTBOX
}, Symbol.toStringTag, { value: "Module" })), HUB = {
  pageType: "Hub"
}, VENUE = {
  pageType: "Venue"
}, SEARCH_RESULTS = {
  pageType: "SearchResults"
}, LANDING = {
  pageType: "Landing"
}, LOCATION_DETAILS = {
  pageType: "LocationDetails"
}, CHECKOUT = {
  pageType: "Checkout"
}, RECEIPT = {
  pageType: "Receipt"
}, MY_PASSES = {
  pageType: "MyPasses"
}, PASS = {
  pageType: "Pass"
}, OUR_APPS = {
  pageType: "OurApps"
}, HELP = {
  pageType: "Help"
}, HOW_IT_WORKS = {
  pageType: "HowItWorks"
}, SIGN_IN_SIGN_UP = {
  pageType: "SignInSignUp"
}, ACCOUNT = {
  pageType: "Account"
}, SEARCH = {
  pageType: "Search"
}, BOOKINGS = {
  pageType: "Bookings"
}, OVERLAY = {
  pageType: "Overlay"
}, ERROR = {
  pageType: "Error"
}, SCAN = {
  pageType: "Scan"
}, FRICTION_FREE_FLOW = {
  pageType: "FrictionFreeFlow"
}, LIST = {
  pageType: "List"
}, DETAILS = {
  pageType: "Details"
}, PORTAL_LOGIN = {
  pageType: "PortalLogin"
}, PORTAL_HOME = {
  pageType: "PortalHome"
}, PORTAL_NAVIGATION = {
  pageType: "PortalNavigation"
}, PORTAL_SETTINGS = {
  pageType: "PortalSettings"
}, PORTAL_REPORTS = {
  pageType: "PortalReports"
}, PORTAL_OPERATIONS = {
  pageType: "PortalOperations"
}, PORTAL_PRICING = {
  pageType: "PortalPricing"
}, PORTAL_VALIDATIONS = {
  pageType: "PortalValidations"
}, PORTAL_COUPONS = {
  pageType: "PortalCoupons"
}, PORTAL_MONTHLY = {
  pageType: "PortalMonthly"
}, PORTAL_PRESALE = {
  pageType: "PortalPresale"
}, PORTAL_TICKETS = {
  pageType: "PortalTickets"
}, PORTAL_INSIGHTS = {
  pageType: "PortalInsights"
}, PORTAL_ALERTS = {
  pageType: "PortalAlerts"
}, PORTAL_ACTIVITY = {
  pageType: "PortalActivity"
}, PageProperties = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ACCOUNT,
  BOOKINGS,
  CHECKOUT,
  DETAILS,
  ERROR,
  FRICTION_FREE_FLOW,
  HELP,
  HOW_IT_WORKS,
  HUB,
  LANDING,
  LIST,
  LOCATION_DETAILS,
  MY_PASSES,
  OUR_APPS,
  OVERLAY,
  PASS,
  PORTAL_ACTIVITY,
  PORTAL_ALERTS,
  PORTAL_COUPONS,
  PORTAL_HOME,
  PORTAL_INSIGHTS,
  PORTAL_LOGIN,
  PORTAL_MONTHLY,
  PORTAL_NAVIGATION,
  PORTAL_OPERATIONS,
  PORTAL_PRESALE,
  PORTAL_PRICING,
  PORTAL_REPORTS,
  PORTAL_SETTINGS,
  PORTAL_TICKETS,
  PORTAL_VALIDATIONS,
  RECEIPT,
  SCAN,
  SEARCH,
  SEARCH_RESULTS,
  SIGN_IN_SIGN_UP,
  VENUE
}, Symbol.toStringTag, { value: "Module" })), events = {
  EventProperties: EventProperties$1,
  ObjectProperties: ObjectProperties$1,
  PageProperties
}, EventProperties = events.EventProperties, ObjectProperties = events.ObjectProperties;
export {
  EventProperties as E,
  ObjectProperties as O
};
//# sourceMappingURL=index-5e4e4f4b.js.map
